import membershipApi from 'api/membership.api';
import { IUserTaskItem, UserTaskTarget } from './model';

export const tasksApi = {
    getByTarget,
    completeByIds,
};

function getByTarget({ tenantId, target }: GetTasksByTargetRequest) {
    return membershipApi.client.get<IUserTaskItem[]>(`UserTasks/Tenants/${tenantId}/Targets/${target}`);
}

function completeByIds({ id }: CompleteTaskByIdRequest) {
    return membershipApi.client.put(`UserTasks?id=${id}`);
}

export type CompleteTaskByIdRequest = {
    id: string;
};

export type CompleteTaskByIdsRequest = {
    ids: string[];
};

export type GetTasksByTargetRequest = {
    tenantId: string;
    target: UserTaskTarget;
};
